var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeOpenStore = function SvgEyeOpenStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 5C5.333 5 .123 11.173.123 11.173a.5.5 0 0 0 0 .656S5.333 18.002 12 18.002c6.667 0 11.877-6.173 11.877-6.173a.5.5 0 0 0 0-.656S18.667 5 12 5Zm0 1c1.315 0 2.57.272 3.735.688A4.993 4.993 0 0 1 12 15.002c-2.768 0-5-2.233-5-5.001 0-1.276.468-2.43 1.25-3.313C9.417 6.27 10.68 6 12 6ZM6.593 7.422a5.951 5.951 0 0 0-.594 2.579A6.008 6.008 0 0 0 12 16a6.008 6.008 0 0 0 5.423-8.579c2.824 1.436 4.856 3.518 5.376 4.08-.813.878-5.312 5.5-10.799 5.5-5.487 0-9.986-4.622-10.799-5.5.52-.564 2.561-2.644 5.392-4.08ZM12 7.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
  })));
};
export { SvgEyeOpenStore as ReactComponent };